// @flow
import { createParser, fields } from '../utils/parse';

export default createParser('PaginationParser', {
  totalPages: fields.number(0, { path: 'page_count' }),
  currentPage: fields.number(0, { path: 'page' }),
});
